<template>
  <!-- Collections ({{ collectionCount }} / {{ subcollectionCount }})<sup> -->
  Datasets ({{ collectionCount }})<sup>
    <InfoPopover popover-placement="top">
      <div>Datasets: {{ collectionCount }}</div>
      <!-- <div>Subcollections: {{ subcollectionCount }}</div> -->
    </InfoPopover>
  </sup>
</template>

<script setup lang="ts">
//@ts-ignore
import { InfoPopover } from "molgenis-components";

// const { collectionCount, subcollectionCount } = defineProps<{
//   collectionCount: number;
//   subcollectionCount: number;
// }>();
const { collectionCount } = defineProps<{
  collectionCount: number;
}>();
</script>

<style scoped>
sup {
  vertical-align: super;
  font-size: small;
}
</style>
